export default __webpack_public_path__ + "static/media/unsplash_image4.8c894998.png";